import React from "react";

function ProfilePageHeader({ title, bgColor }) {
  let pageHeader = React.createRef();

  const padding =
    document.body.clientWidth >= 1024 ||
    document.documentElement.clientWidth > 1024
      ? "5rem 0 0rem 0rem"
      : "5rem 0 1rem 0rem";
  const size =
    document.body.clientWidth >= 1024 ||
    document.documentElement.clientWidth >= 1024
      ? true
      : false;
  return (
    <>
      <div
        style={{
          backgroundColor: bgColor,
          padding: padding,
        }}
        className="section"
        data-parallax={true}
        ref={pageHeader}
      >
        {title ? (
          <h1
            className="text-700 text-center mb-3"
            style={{
              fontSize: size ? "3.5rem" : "2rem",
              fontWeight: "700",
              letterSpacing: "0.5px",
              color: bgColor === "#000" ? "#fff" : "#000",
              background: bgColor === "#000" ? "linear-gradient(135deg, #ffb41f 0%, #ccb63a 100%)" : "none",
              WebkitBackgroundClip: bgColor === "#000" ? "text" : "none",
              WebkitTextFillColor: bgColor === "#000" ? "transparent" : "inherit",
              backgroundClip: bgColor === "#000" ? "text" : "none",
            }}
          >
            {title}
          </h1>
        ) : (
          ""
        )}
        {title && bgColor === "#000" && (
          <div
            style={{
              width: "100px",
              height: "4px",
              background: "linear-gradient(90deg, #ffb41f, #ccb63a)",
              borderRadius: "2px",
              margin: "0 auto",
            }}
          />
        )}
      </div>
    </>
  );
}

export default ProfilePageHeader;
